module.exports = __webpack_public_path__ + "img/anchorPoint_icon.f9e06487.png";